module.exports = __webpack_public_path__ + "img/img-f8a368c6.c604c0ac.png";